/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, useState, useEffect, useRef } from "react";
import styles from "./Layout.module.scss";
import { useDimensions } from "../../../logic/Dimensions";
import MobileHeader from "../../Mobile/Header";
import Header from "../../Header";
import Advertisment from "../../Advertisment";
import { useAdBanner } from "../../../logic/useAdBanner";
import { useLocation } from "react-router-dom";
import { useOtherDetails } from "../../../logic/useOtherDetails";
import HeaderComponent from "../../customHeader";
import CustomMobileHeader from "../../Mobile/Header/customMobileHeader";

const Footer = lazy(() => import("../../Footer"));
const Partners = lazy(() => import("../../Partners"));
const BottomTab = lazy(() => import("../../BottomTab"));

const CommonLayout = ({ children }) => {
  const adBannerData = useAdBanner();
  const { width } = useDimensions();
  const location = useLocation();
  const advertismentRef = useRef();
  const headerRef = useRef();
  const [stickyMenu, setStickyMenu] = useState(false);
  const [showAd, setShowAd] = useState(true);
  const [imageHeight, setImageHeight] = useState(0);
  const partnersData = useOtherDetails();

  useEffect(() => {
    if (location.pathname !== "/") {
      setShowAd(false);
    }
  }, [location]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, {});
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, {});
    window.addEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    if (adBannerData && adBannerData.url && location.pathname === "/") {
      setShowAd(true);
    } else {
      setShowAd(false);
    }
  }, [adBannerData, location.pathname]);

  const handleScroll = () => {
    if (
      advertismentRef &&
      advertismentRef.current &&
      advertismentRef.current.getBoundingClientRect().height &&
      advertismentRef.current.getBoundingClientRect().height >= 1 &&
      window.pageYOffset >
        advertismentRef.current.getBoundingClientRect().height -
          headerRef.current.getBoundingClientRect().height
    ) {
      setStickyMenu(true);
    } else {
      setStickyMenu(false);
    }
  };
  const handleCloseAd = () => {
    setStickyMenu(false);
    setShowAd(false);
    setImageHeight(0);
  };

  const handleResize = (e) => {
    const windowSize = window.innerWidth;
    if (
      location.pathname === "/" &&
      advertismentRef.current &&
      advertismentRef.current.clientHeight
    ) {
      setImageHeight(advertismentRef.current.clientHeight);
    }

    if (windowSize < 992) {
      setImageHeight(0);
    }
  };

  const handleImageLoaded = (e) => {
    if (
      location.pathname === "/" &&
      advertismentRef &&
      advertismentRef.current &&
      advertismentRef.current.clientHeight &&
      adBannerData?.url
    ) {
      setImageHeight(advertismentRef.current.clientHeight);
    }
  };

  return (
    <>
      <div
        className={`layout_wrap ${showAd === false ? "" : "ads"}`}
        style={{ paddingTop: adBannerData?.url ? imageHeight : 0 + "px" }}
      >
        {/* Add class "ads" to layout_wrap for showing ads */}
        {/* breakpoint:1449, 1399,1199*/}

        {showAd ? (
          <Advertisment
            ref={advertismentRef}
            closeAd={handleCloseAd}
            adBannerData={adBannerData}
            imageLoaded={handleImageLoaded}
          />
        ) : null}

        <div className="page_container">
          {width > 1024 ? (
            <HeaderComponent
              stickyMenu={stickyMenu}
              ref={headerRef}
              partnersData={partnersData}
            />
          ) : (
            // <MobileHeader
            //   stickyMenu={stickyMenu}
            //   ref={headerRef}
            //   partnersData={partnersData}
            // />
            <CustomMobileHeader
              stickyMenu={stickyMenu}
              ref={headerRef}
              partnersData={partnersData}
            />
          )}
          <main
            className={`${styles.page_content} ${
              window.location.pathname.includes("mass-petition")
                ? `${styles.bg_masspetition}`
                : ``
            }`}
          >
            {children}
            {window.location.pathname?.includes("prayer-partners") ? null : (
              <Partners partnersData={partnersData} />
            )}
          </main>
          <Footer partnersData={partnersData} />
          {width < 1024 ? <BottomTab /> : ""}
        </div>
      </div>
    </>
  );
};

export default CommonLayout;
